import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-pop-test',
  templateUrl: './pop-test.component.html',
  styleUrls: ['./pop-test.component.scss']
})
export class PopTestComponent implements OnInit {
  public pinId;

  constructor() {
  }

  ngOnInit(): void {
  }

  attachToPin(pin) {
    if (pin?.pin) {
      this.pinId = pin.pin.id;
    } else {
      this.pinId = pin.id;
    }

  }

}
